import InnerComponent from '@Components/Logistics/GateDocument/GateDocumentList';
import orgContainer from '@Components/AppContainer';

const ListGateDocument = () => ((orgContainer(InnerComponent)));
export default ListGateDocument;
